(function () {
  const bindAll = (root) => {
    initHero(root);
    initBestsellers(root);
    initProductCards(root);
    initSocialProof(root);
    initFaq(root);
    initHeaderLogoFallback(root);
    initHeaderCta(root);
  };

  const initHero = (root) => {
    for (const hero of root.querySelectorAll('[data-cirkul-hero]')) {
      if (hero.dataset.bound === 'true') continue;
      hero.dataset.bound = 'true';

      const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
      const bullets = Array.from(hero.querySelectorAll('[data-hero-bullet]'));
      let activeIndex = 0;
      let timer;

      const showSlide = (nextIndex) => {
        activeIndex = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => slide.classList.toggle('is-active', index === activeIndex));
        bullets.forEach((bullet, index) => bullet.classList.toggle('is-active', index === activeIndex));
      };

      const restart = () => {
        window.clearInterval(timer);
        if (slides.length < 2) return;
        timer = window.setInterval(() => showSlide(activeIndex + 1), 5500);
      };

      bullets.forEach((bullet, index) => {
        bullet.addEventListener('click', () => {
          showSlide(index);
          restart();
        });
      });

      showSlide(0);
      restart();
    }
  };

  const initBestsellers = (root) => {
    for (const section of root.querySelectorAll('[data-cirkul-bestsellers]')) {
      if (section.dataset.bound === 'true') continue;
      section.dataset.bound = 'true';

      const tabs = Array.from(section.querySelectorAll('[data-bestseller-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-bestseller-panel]'));

      const activate = (key) => {
        tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.bestsellerTab === key));
        panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.bestsellerPanel === key));
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activate(tab.dataset.bestsellerTab));
      });

      section.querySelectorAll('[data-scroll-track]').forEach((button) => {
        button.addEventListener('click', () => {
          const key = button.dataset.scrollTrack;
          const panel = section.querySelector(`[data-bestseller-panel="${key}"]`);
          const track = panel?.querySelector('[data-bestseller-track]');
          if (!track) return;
          const direction = button.dataset.direction === 'prev' ? -1 : 1;
          const shift = Math.max(track.clientWidth * 0.75, 280);
          track.scrollBy({ left: direction * shift, behavior: 'smooth' });
        });
      });

      if (tabs[0]) activate(tabs[0].dataset.bestsellerTab);
    }
  };

  const initProductCards = (root) => {
    for (const card of root.querySelectorAll('[data-cirkul-product-card]')) {
      if (card.dataset.bound === 'true') continue;
      card.dataset.bound = 'true';

      const image = card.querySelector('[data-card-image]');
      const price = card.querySelector('[data-card-price]');
      const compare = card.querySelector('[data-card-compare]');
      const links = card.querySelectorAll('[data-card-link], [data-card-link-title], [data-card-link-button]');
      const actionLink = card.querySelector('[data-card-link-button]');
      const defaultLabel = card.dataset.cardDefaultLabel || actionLink?.textContent?.trim() || '+ Options';

      card.querySelectorAll('[data-card-swatch]').forEach((swatch) => {
        swatch.addEventListener('click', () => {
          card.querySelectorAll('[data-card-swatch]').forEach((node) => node.classList.remove('is-active'));
          swatch.classList.add('is-active');

          const nextImage = swatch.dataset.cardImage;
          const nextImageAlt = swatch.dataset.cardImageAlt;
          const nextPrice = swatch.dataset.cardPrice;
          const nextCompare = swatch.dataset.cardCompare;
          const nextUrl = swatch.dataset.cardUrl;
          const nextVariantId = swatch.dataset.cardVariantId;
          const nextVariantTitle = swatch.dataset.cardVariantTitle;
          const nextAvailable = swatch.dataset.cardAvailable !== 'false';

          if (image && nextImage) {
            image.src = nextImage;
            image.srcset = nextImage;
          }
          if (image && nextImageAlt) image.alt = nextImageAlt;
          if (price && nextPrice) price.textContent = nextPrice;

          if (compare) {
            if (nextCompare) {
              compare.textContent = nextCompare;
              compare.classList.remove('is-hidden');
            } else {
              compare.textContent = '';
              compare.classList.add('is-hidden');
            }
          }

          if (nextUrl) {
            links.forEach((link) => link.setAttribute('href', nextUrl));
          }

          if (nextVariantId) card.dataset.cardSelectedVariantId = nextVariantId;
          if (nextVariantTitle) card.dataset.cardSelectedVariantTitle = nextVariantTitle;
          card.classList.toggle('is-unavailable', !nextAvailable);
          if (actionLink) actionLink.textContent = nextAvailable ? defaultLabel : 'Unavailable';
        });
      });
    }
  };

  const initSocialProof = (root) => {
    for (const section of root.querySelectorAll('[data-cirkul-social-proof]')) {
      if (section.dataset.bound === 'true') continue;
      section.dataset.bound = 'true';

      const tabs = Array.from(section.querySelectorAll('[data-social-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-social-panel]'));

      const activate = (key) => {
        tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.socialTab === key));
        panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.socialPanel === key));
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activate(tab.dataset.socialTab));
      });

      if (tabs[0]) activate(tabs[0].dataset.socialTab);
    }
  };

  const initFaq = (root) => {
    for (const item of root.querySelectorAll('[data-faq-item]')) {
      if (item.dataset.bound === 'true') continue;
      item.dataset.bound = 'true';

      const trigger = item.querySelector('[data-faq-trigger]');
      if (!trigger) continue;

      trigger.addEventListener('click', () => {
        item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      });
    }
  };

  const initHeaderLogoFallback = (root) => {
    const logoAsset = window.CirkulTheme?.logoAsset;
    if (!logoAsset) return;

    const header = root.querySelector('header-component');
    if (!header) return;

    const rootHref = `${window.location.origin}/`;
    const candidates = Array.from(header.querySelectorAll(`a[href="/"], a[href="${rootHref}"]`));
    const target = candidates.find((node) => {
      if (node.querySelector('img, svg')) return false;
      return /my store/i.test(node.textContent || '');
    });

    if (!target || target.dataset.cirkulLogoBound === 'true') return;

    target.dataset.cirkulLogoBound = 'true';
    target.classList.add('cirkul-header-logo-fallback');
    target.innerHTML = `<img src="${logoAsset}" alt="Cirkul">`;
  };

  const refreshHeaderMetrics = () => {
    const header = document.querySelector('header-component');
    const headerGroup = document.querySelector('#header-group');
    const headerTopRow = header?.querySelector('.header__row--top');
    if (!header || !headerGroup) return;

    const headerHeight = header.offsetHeight;
    let headerGroupHeight = 0;
    for (const element of Array.from(headerGroup.children)) {
      if (!(element instanceof HTMLElement) || element === header) continue;
      headerGroupHeight += element.offsetHeight;
    }

    if (header.hasAttribute('transparent') && header.parentElement?.nextElementSibling) {
      headerGroupHeight += headerHeight;
    }

    document.body.style.setProperty('--header-height', `${headerHeight}px`);
    document.body.style.setProperty('--header-group-height', `${headerGroupHeight}px`);

    if (headerTopRow) {
      document.body.style.setProperty('--top-row-height', `${headerTopRow.offsetHeight}px`);
    }
  };

  const initHeaderCta = (root) => {
    const header = root.querySelector('header-component') || document.querySelector('header-component');
    if (!header) return;

    const rightColumn = header.querySelector('.header__column--right');
    if (!rightColumn || rightColumn.querySelector('.cirkul-header-cta')) return;

    const cta = document.createElement('a');
    cta.className = 'cirkul-header-cta';
    cta.href = '/collections/starter-kits';
    cta.textContent = 'Build Your Bundle';
    cta.setAttribute('aria-label', 'Build Your Bundle');

    const searchAction = rightColumn.querySelector('.search-action');
    if (searchAction) {
      rightColumn.insertBefore(cta, searchAction);
    } else {
      rightColumn.prepend(cta);
    }

    window.requestAnimationFrame(refreshHeaderMetrics);
  };

  document.addEventListener('DOMContentLoaded', () => bindAll(document));
  document.addEventListener('shopify:section:load', (event) => bindAll(event.target));
})();
